import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDrivingData } from "../../../../../store/Api";
import ListAppliedList from "./ListAppliedList";

export default function AppliedList() {
  const drivingLicData = useSelector((state) => state.drivingData);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  useEffect(() => {
    dispatch(getDrivingData(token));
  }, []);

  const updateData = () => {
    dispatch(getDrivingData(token));
  };
  console.log("log to be printed here......",drivingLicData)
  return (
    <>
      <ListAppliedList
        titles={[
          "SR.NO.",
          "employee ID",
          "employee NAME",
          "ACTUAL PROFESSION",
          "IQAMA PROFESSION",
          "VISA PROVIDER",
          "SPONSOR",
          "CLIENT NAME",
          "IQAMA NUMBER",
          "LICENCE TYPE",
          "DRIVING LICENCE APPLY DATE",
          "DRIVING LICENCE ISSUE DATE",
          "DRIVING LICENCE EXPIRY DATE",
          "DRIVING LICENCE VALID DAYS",
          "DRIVING LICENCE ADDMISSION FEES",
          "DRIVING LICENCE MEDICAL FEES",
          "DRIVING LICENCE GOVT. FEES",
          "DRIVING LICENCE INDUCEMENT FEES",
          "LICENCE STATUS",
          "",
        ]}
        list={drivingLicData}
        loading={loading}
        token={token}
        updateData={updateData}
      />
    </>
  );
}
